import { setSentryUser } from "../../lib/sentryUser"
import { resetOfficesCache } from "../../lib/officeVisibilityCache"
import { clearAmbientSelection } from "../../lib/ambientHeaders"
import { isPortalRole } from "../../lib/portalAudience"

export const resolveLogoutRedirect = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user'))
    if (user?.role) {
      return isPortalRole(user.role) ? '/' : '/team-portal'
    }
  } catch (e) {}

  return localStorage.getItem('portalAccountId') ? '/' : '/team-portal'
}

export const logout = () => {
  const redirectTo = resolveLogoutRedirect()

  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')
  localStorage.removeItem('user')
  // Office and brand together: a brand or an office left behind means the next person to sign in on
  // this machine acts as the previous person's firm until something refuses them.
  clearAmbientSelection()
  resetOfficesCache()
  setSentryUser(null)

  window.location.href = redirectTo
}
